import aframe from "aframe";
import firebase from "firebase/app";
import "firebase/database";

const config = {
  apiKey: "AIzaSyBWa3EnVHo7wmIuveEPi-uda8Kzci6mCFI",
  authDomain: "trajectile-command.firebaseapp.com",
  databaseURL: "https://trajectile-command.firebaseio.com",
  projectId: "trajectile-command",
  storageBucket: "trajectile-command.appspot.com",
  messagingSenderId: "864002189800"
};
firebase.initializeApp(config);

const db = firebase.database().ref("scores");

async function getScores() {
  return new Promise((resolve, reject) => {
    db
      .orderByChild("score")
      .limitToLast(10)
      .on("value", resolve, reject);
  });
}

function putScore(name, score) {
  var db = firebase.database().ref("scores");
  db.push({ name: name.toUpperCase(), score: Math.trunc(score) });
}

aframe.registerComponent("high-scores", {
  init() {
    this.rows = this.el.querySelectorAll(".row");
  },
  play() {
    this.syncLatestScores();
  },
  syncLatestScores() {
    getScores().then(response => {
      const data = response.val();
      if (data) {
        this.scores = Object.values(data);
      } else {
        this.scores = [];
      }
      if (this.scores.length < 10) {
        for (let i = this.scores.length; i < 10; i++) {
          this.scores.push({ name: "EMPTY", score: 0 });
        }
      }
      this.scores.sort(function (a, b) {
        return a["score"] < b["score"] ? 1 : a["score"] > b["score"] ? -1 : 0;
      });
      this.applyScoresToRows(this.scores);
    });
  },
  applyScoresToRows(scores) {
    for (let i = 0; i < this.rows.length; i++) {
      const row = this.rows[i];
      const score = this.scores[i];
      row
        .querySelector("[text__name]")
        .setAttribute("text__name", "value", score.name);
      row
        .querySelector("[text__score]")
        .setAttribute("text__score", "value", score.score);
    }
  },
  isHighScore(score) {
    for (const hiScore of this.scores) {
      if (score > hiScore.score) {
        return true;
      }
    }
    return false;
  },
  addHighScore(name, score) {
    putScore(name, score);
  }
});
